import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'achoo-loader',
  templateUrl: './achoo-loader.component.html',
  styleUrls: ['./achoo-loader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AchooLoaderComponent {
  @Input() normalPlaceholder: boolean;
  @Input() facebookPlaceholder: boolean;
  @Input() textPlaceholder: boolean;
  @Input() warningMessage: string;
  @Input() showWarningMessage = false;
  @Input() groupPlaceholder = false;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-loader/achoo-loader.component.ts